var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tagTempLave_wapper",staticStyle:{"margin-bottom":"20px"}},[_c('canvas',{staticClass:"exportCanvas",attrs:{"id":_vm.plankIndex + 'printTagLave' + _vm.index,"labelName":_vm.cancleName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }